import React from "react";
import styled from "styled-components";
import useDocumentTitle from "common/useDocumentTitle";

const PageNotFoundContainer = styled.div`
  width: 480px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border: none;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const PageNotFoundHeader = styled.h1`
  color: #333;
  font-size: 1.8em;
`;

function PageNotFound({ errorMsg }) {
  useDocumentTitle(errorMsg ? errorMsg : "Seite nicht gefunden 404");

  return (
    <PageNotFoundContainer>
      <PageNotFoundHeader>
        {errorMsg ? errorMsg : "Seite nicht gefunden 404"}
      </PageNotFoundHeader>
    </PageNotFoundContainer>
  );
}

export default PageNotFound;
